import { DogsList } from "../../components/DogsList/DogsList";
import "./MainPage.scss";

export const MainPage = () => {

  return (
    <DogsList />
  );
};
